/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AreaChart = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 3v18h18" }],
    ["path", { d: "M7 12v5h12V8l-5 5-4-4Z" }]
  ]
];

export { AreaChart as default };
//# sourceMappingURL=area-chart.js.map
